module.exports = __webpack_public_path__ + "img/checkin.d7c9759b.png";